export default [{
	titulo: 'Notícias',
	icone: 'menu-icon fa fa-caret-right',
	url: '/site/noticias',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]